import React, { useRef } from 'react';
import MUIAutocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const AutoComplete = ({
	name,
	value,
	values,
	options,
	label,
	onChange,
	multiple,
	helperText,
	error,
	required,
	useOtherValues = false,
	otherValuesName,
	fixedBottomPlacement = false,
	popperMaxHeight,
	...props
}) => {
	let opts = options;
	if (useOtherValues) opts = values[otherValuesName];
	const popperRef = useRef(null);

	return (
		<MUIAutocomplete
			clearOnBlur={false}
			value={value || (multiple ? [] : null)}
			options={opts || []}
			renderInput={(params) => <TextField {...params} sx={{ marginBottom: 2 }} helperText={helperText} error={error} label={label} required={required} />}
			onChange={(e, value) => onChange({ target: { name, value } })}
			multiple={multiple}
			filterSelectedOptions
			onOpen={fixedBottomPlacement ? () => {
				setTimeout(() => {
					if (popperRef.current) {
						popperRef.current.scrollIntoView({
							behavior: 'smooth',
							block: 'end',
						});
					}
				}, 0);
			} : undefined}
			ListboxProps={{
				style: {
					maxHeight: popperMaxHeight ?? undefined,
				},
			}}
			componentsProps={{
				popper: fixedBottomPlacement ? {
					ref: popperRef,
					disablePortal: true,
					placement: 'bottom',
					modifiers: [{
						name: 'flip',
						enabled: false,
					}],
					sx: {
						paddingBottom: '10px',
					},
				} : undefined,
				
			}}
			{...props}
		/>
	);
};

AutoComplete.type = 'AutoComplete';

AutoComplete.spec = [
	{
		name: 'AutoComplete',
		key: 'AutoComplete',
		hidden: true,
		icon: 'Filter',
		title: 'AutoComplete',
		category: 'input',
		translatable: ['label', 'options'],
		fields: [
			{
				type: 'TextField',
				label: 'Label',
				name: 'label',
			},
			{
				type: 'repeater',
				label: 'Options',
				name: 'options',
				fields: [
					{
						type: 'TextField',
						name: 'Label',
						label: 'Option label',
					},
					{
						type: 'TextField',
						name: 'id',
						label: 'Option value',
					},
				],
			},
		],
	},
];

export default AutoComplete;
